import * as React from 'react'

import { Section } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import type { Back } from 'modules/core/components/Card/types'
import i18n from 'modules/core/lib/i18n'

import type { Automation } from 'modules/automations/store/models/Automation'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import HistoryEntriesTable from './entries_table'

interface AutomationHistoryProps {
  automation: Automation
  back: Back
}

const AutomationHistory = ({
  automation,
  back,
  children,
}: React.PropsWithChildren<AutomationHistoryProps>) => {
  const backLink = {
    href: back.href,
    label: back.label || '',
  }

  return (
    <ResponsivePage.Body backLink={backLink} showHeader={false}>
      <Section
        illustration="document-edit"
        title={i18n.t('automations.show.history.title')}
        description={i18n.t('automations.show.history.description')}
      >
        <HistoryEntriesTable automation={automation} />
      </Section>
      {children}
    </ResponsivePage.Body>
  )
}

export default observer(AutomationHistory)
